// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-64f92760] .bj-page .el-form-item__label {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
